export default __webpack_public_path__ + "static/media/Classical Dance.58be8805.PNG";